import * as cloneDeep from 'lodash/cloneDeep';
import * as isEmpty from 'lodash/isEmpty';
import * as merge from 'lodash/merge';

import { DefaultChartConfig } from './default-chart.config';

/**
 * @description applyCustomAttributesToConfiguration: returns the chart config merged with the given custom attributes
 * 
 * Please only pass in valid HighCharts attributes as defined in the docs
 * Lodash merge will not overwrite a defined value with an undefined value
 */
export class ChartConfigHelper {
	public static applyCustomAttributesToConfiguration(customAttributes: any, config: DefaultChartConfig): DefaultChartConfig {
		const newConfig: DefaultChartConfig = cloneDeep(config);
		if (!customAttributes || isEmpty(customAttributes)) {
			return newConfig;
		} else {
			return merge(newConfig, customAttributes);
		}
	}
}

